import { useEffect, useState } from 'react'
import { List } from 'antd'
import { changeTypes } from '../helpers'
import './Changes.scss'

Changes = ({ nodeId, diffs }) ->

  [loading, setLoading] = useState(true)
  [data, setData] = useState(undefined)

  useEffect( ->
    return unless nodeId?
    ( ->
      setLoading(true)
      if diffs.type is changeTypes.UPDATED
        try
          node = await Weaver.Node.load(nodeId)
          setData(await mergeWithDbNode(node))
        catch
          setData(diffs)
      else
        setData(diffs)
      setLoading(false)
    )()
    undefined
  , [nodeId])

  mergeWithDbNode = (node) ->
    parsedRelations = _.mapValues(node.relations(), (val) ->
      _.map(val.all(), ({ nodeId }) -> { target: nodeId })
      )

    _.merge({
        attributes: node.attributes()
        relations: parsedRelations
      }, diffs)

  arrangeLines = ->
    heading = { type: "", text: "id: #{nodeId}" }
    lnBreak = { type: "none", text: "" }

    arr = [heading]
    arr.push(lnBreak) if not _.isEmpty(data.attributes)

    _.map(data.attributes, (val, key) ->
      arr.push({ type: val.type, text: "#{ key }: #{ val.value or val }" })
    )

    arr.push(lnBreak) if not _.isEmpty(data.relations)

    rels = _.map(data.relations, (val, key ) ->
      arr.push({ type: val.type, text: "#{ key }: [" })
      val.map((v) -> arr.push({ type: v.type, text:"""  to: #{v.target}""" }))
      arr.push({ type: "", text: "]" })
    )

    arr

  buildLines = ->
    <div className="diff-changes-text">
      <ol>
        {
          _.map(arrangeLines(), ({ type, text }, i) ->
            <li
              className={ if (type is 'none' or diffs?.type is 'UPDATED') then type else diffs?.type }
              key="#{nodeId}-#{i}-#{text}"
            >
              { text }
            </li>
          )
        }
      </ol>
    </div>

  !loading && buildLines() || <div />

export default Changes
